import { Component, output, Input } from '@angular/core';

import { IRoomOccupancy } from 'core-lib';

import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { SettingsService } from 'core-lib';
import { IncrementorComponent } from "core-lib";
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-room-picker',
    imports: [
        ButtonModule,
        SelectModule,
        FormsModule,
        IncrementorComponent,
        TranslateModule
    ],
    templateUrl: './room-picker.component.html',
    styleUrl: './room-picker.component.scss'
})
export class RoomPickerComponent {

  onValueChange = output<IRoomOccupancy[]>();
  onCloseRoomPicker = output<void>();

  @Input() rooms:IRoomOccupancy[] = [{
    adults: 2,
    children: 0,
    childAges: []
  }];

  maxPersons:number;
  maxAdults:number;
  maxChildren:number;
  canBookChildren:boolean
  maxPersonError:any = [];

  constructor(public settings:SettingsService, private translate:TranslateService) {}

  ngOnInit() {
    this.maxPersons = this.settings.get('searchMask.maxPersonsPerRoom') ?? 4;
    this.maxAdults = this.settings.get('searchMask.maxAdultsPerRoom') ?? 4;
    this.maxChildren = this.settings.get('searchMask.maxChildrenPerRoom') ?? 3;
    this.canBookChildren = this.settings.get('searchMask.canBookChildren');
    this.rooms.forEach((room:IRoomOccupancy, index) => {
      this.maxPersonError.push(this.getMaxPersonErrorForRoom(index));
    });
  }

  addRoom():void {
    this.rooms.push({
      adults: this.settings.get('searchMask.defaultAdults') ?? 2,
      children: this.settings.get('searchMask.defaultChildren') ?? 0,
      childAges: []
    });
    this.maxPersonError.push(false);
    this.onValueChange.emit(this.rooms);
  }

  changeAdults(value:any, roomIndex:number) {
    
    this.rooms[roomIndex].adults = parseInt(value);
    this.onValueChange.emit(this.rooms);

    this.maxPersonError[roomIndex] = this.getMaxPersonErrorForRoom(roomIndex);

    
  }

  changeChildren(value:any, roomIndex:number) {

    value = parseInt(value);
    this.rooms[roomIndex].children = value;

    if (this.rooms[roomIndex].childAges.length < value) {
      for (let i = 0; i < value; i++) {
        if (i >= this.rooms[roomIndex].childAges.length) {
          this.rooms[roomIndex].childAges.push(null);
        }
      }
    }
    if (this.rooms[roomIndex].childAges.length > value) {
      let amountToRemove = this.rooms[roomIndex].childAges.length - value;
      this.rooms[roomIndex].childAges.splice(value, amountToRemove);
    }

    
    this.onValueChange.emit(this.rooms);

    this.maxPersonError[roomIndex] = this.getMaxPersonErrorForRoom(roomIndex);

  }

  changeChildAge(changeEvent:any, roomIndex:number, childIndex:number) {
    this.rooms[roomIndex].childAges[childIndex] = parseInt(changeEvent.value);
    this.onValueChange.emit(this.rooms);
  }

  removeRoom(index:number):void {
    this.rooms.splice(index,1);
    this.maxPersonError.splice(index,1);
    this.onValueChange.emit(this.rooms);
  }

  getChildrenAgeConfig() {
    let max = this.settings.get('searchMask.maxChildAge') ?? 17;
    return Array.from({ length: max + 1 }, (_, i) => ({
      label: i === 0 ? this.translate.instant('sm.Infant') : String(i),
      value: i
    }));
  }

  hasUnselectedChildAges(): boolean {
    return this.rooms.some(room => room.childAges.some(age => age === null));
  }

  getMaxPersonErrorForRoom(roomIndex:number) {
    if (this.rooms[roomIndex].adults + this.rooms[roomIndex].children >= this.maxPersons) {
      return true;
    }
    else {
      return false;
    }
  }

  closeRoomPicker() {
    this.onCloseRoomPicker.emit();
  }

}
